module.exports = __webpack_public_path__ + "img/bounce.5ca5756a.svg";